const isEmpty = (value: unknown): boolean => {
  const array = Array.isArray(value) ? value : Object.keys(value || {})
  return array.length === 0
}

export default isEmpty
